import commonService from "./common-service";

class AddendumMedPassService {

    async getAddendumPatientsBySearch(fac_id, search) {
        try {
            const response = await commonService.postToServer(`EMar/AddendumPatients?fac_id=${fac_id}&search=${search}`, {});
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async getPatientAddendumMedications(pat_id, date, passes) {
        try {
            const response = await commonService.postToServer(`EMar/GetPatientAddendumMedications?pat_id=${pat_id}&date=${date}`, passes);
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async postPatientAddendumMedications(payload) {
        try {
            const response = await commonService.postToServer("EMar/PatientAddendumMedications", payload);
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async getPatientAddendumAdministrations(pat_id, date, passes) {
        try {
            const response = await commonService.postToServer(`EMar/GetPatientAddendumAdministrations?pat_id=${pat_id}&date=${date}`, passes);
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
}

export default new AddendumMedPassService();
